import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { ADDITIONAL_TIME_APPROVAL_STATUS } from 'src/app/work-and-rest-user/enums/additional-time-approval.status.enum';

@Component({
  selector: 'app-work-and-rest-work-approval-template',
  standalone: false,
  templateUrl: './work-and-rest-work-approval-template.component.html',
  styleUrl: './work-and-rest-work-approval-template.component.scss',
})
export class WorkAndRestWorkApprovalTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;
  @Input() buttonFunctions: { [key: string]: () => void };

  ADDITIONAL_TIME_APPROVAL_STATUS = ADDITIONAL_TIME_APPROVAL_STATUS;
  readonly dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
}
